
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DesktopHeader extends Vue {
    @Prop({ default: '' })
    private title!: string;

}
